module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/a-function.js
// module id = 156
// module chunks = 0